import type {IUser} from '@/api/types/user';

export const userDefault: IUser = {
  id: '',

  email: '',
  name: '',
  username: null,

  roles: [],
  tech_roles: [],
  view_roles: [],
  view_roles_map: [],
};
